<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <div class="sc-option" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="show = true">
                <div class="sc-option-content">
                    {{ activeName }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="show"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelect(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'carEngineVolume',
                keyName: '排量',
                show: false,
                activeName: formBean.engineVolumeName || '请选择排量',
                list: [{
                    value: '0-1.0',
                    name: '1.0L以下'
                }, {
                    value: '1.1-1.6',
                    name: '1.1L-1.6L'
                }, {
                    value: '1.6-2.0',
                    name: '1.6L-2.0L'
                }, {
                    value: '2.0-2.5',
                    name: '2.0L-2.5L'
                }, {
                    value: '2.5-3.0',
                    name: '2.5L-3.0L'
                }, {
                    value: '3.0-4.0',
                    name: '3.0L-4.0L'
                }, {
                    value: '4.0-1000',
                    name: '4.0L以上'
                }, {
                    value: false,
                    name: '不限'
                }]
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.show = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavEngine.vue?5307ec02